//import moment from 'moment';
//import {  toast } from 'react-toastify';
import React from 'react';

export const loadError = (error) => {
    let message = ""
    let errorCode = false
    if (error.response) {
        errorCode = error.response.status
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.data.name) {
            message = error.response.data.name
        }
        if (errorCode === 403) {
            message = error.response.data.detail
        }
        if (errorCode === 500) {
            message = error.response.statusText
        }
        if (errorCode === 502) {
            message = "Calculation Time Out."
        }
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        message = error.request
    } else {
        // Something happened in setting up the request that triggered an Error

        message = "Error: Please Contact Support"
        // if (error.response && error.repsonse.data) {
        //     let missingDataDetails = error.response.data
        //     for (const [key, value] of Object.entries(missingDataDetails)) {
        //         message = message + ": " + key + "= " + value
        //     }
        // }
    }

    let options = {};
    if (message === "") {
        message = "Error: Please Contact Support"
        // if (error.response && error.response.data) {
        //     let missingDataDetails = error.response.data
        //     for (const [key, value] of Object.entries(missingDataDetails)) {
        //         message = message + "\n " + key + "= " + value
        //     }
        // }
    }
    options = {
        code: errorCode,
        position: "top-right",
        message: message,
        type: "warning",
        icon: <i className={"tim-icons icon-alert-circle-exc"} />,
        autoClose: 10000
    };
    return (options)
}